import React from 'react'
import { t } from "i18next";
import { Modal, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form';

function CompanyLoginModal({ showModal, handleClose, isLoading, handleLogin }) {
    const {
        register,
        setError,
        handleSubmit,
        formState: { errors },
    } = useForm();

    return (
        <Modal show={showModal} onHide={handleClose} className="login-modal">
            <Modal.Header closeButton >
                <Modal.Title role="heading" aria-label={t("loginForCompaniesAndOrganizations")}>{t("loginForCompaniesAndOrganizations")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit((data) => handleLogin(data, setError))}>
                    <div className="mb-3 input-field">
                        <label htmlFor='email'>{t("Email")}</label>
                        <div>
                            <input
                                {...register("email", {
                                    required: t("Required"),
                                    pattern: {
                                        value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                        message: t("InvalidEmail")
                                    }
                                })}
                                id="email"
                            />
                            <span className="text-danger">{errors.email?.message}</span>
                        </div>
                    </div>
                    <div className="mb-3 login-btn justify-content-end input-field">
                        <button
                            aria-label={t("checkEmail")}
                            className='comp-modal-login-btn'
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading && <Spinner className="spinner" animation="border" />}{t("checkEmail")}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CompanyLoginModal